<script setup>
import { useReducedMotion } from '@vueuse/motion';

const reducedMotion = useReducedMotion();
</script>

<template>
    <div class="marquee flex overflow-hidden select-none motion-reduce:flex-col motion-reduce:overflow-visible">
        <div
            v-for="index in 2"
            :key="index"
            v-motion
            :initial="{
                transform: 'translateX(0)'
            }"
            :enter="reducedMotion ? {} : {
                transform: 'translateX(-100%)',
                transition: {
                    duration: 30000,
                    repeat: Infinity,
                    repeatType: 'loop',
                    ease: 'linear',
                },
            }"
            class="marquee__group flex justify-around items-center shrink-0 px-4 min-w-full gap-8 motion-reduce:flex-wrap motion-reduce:justify-start"
            :class="{ 'motion-reduce:hidden': index !== 1 }"
            :aria-hidden="index !== 1"
        >
            <slot />
        </div>
    </div>
</template>

<style>
.marquee {
    mask-image: linear-gradient(
        to right,
        rgba(0, 0, 0, 0) theme('spacing.6'),
        rgb(0, 0, 0) theme('spacing.12'),
        rgb(0, 0, 0) calc(100% - theme('spacing.12')),
        rgba(0, 0, 0, 0) calc(100% - theme('spacing.6'))
    );

    @media screen(md) {
        mask-image: linear-gradient(
            to right,
            rgba(0, 0, 0, 0) theme('spacing.8'),
            rgb(0, 0, 0) theme('spacing.16'),
            rgb(0, 0, 0) calc(100% - theme('spacing.16')),
            rgba(0, 0, 0, 0) calc(100% - theme('spacing.8'))
        );
    }

    @media screen(lg) {
        mask-image: linear-gradient(
            to right,
            rgba(0, 0, 0, 0) theme('spacing.16'),
            rgb(0, 0, 0) theme('spacing.24'),
            rgb(0, 0, 0) calc(100% - theme('spacing.24')),
            rgba(0, 0, 0, 0) calc(100% - theme('spacing.16'))
        );
    }
}

@media (prefers-reduced-motion: reduce) {
    .marquee {
        mask-image: none;
    }

    .marquee__group {
        animation-play-state: paused;
    }
}
</style>
